import { useEffect, useRef, useState } from 'react';

import useStore from '@/state';
import { IStore } from '@/state/slices/typings';

const useDebounceStore = <T>(
	selector: (state: IStore) => T,
	debounceTime: number,
): [T, T] => {
	const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);
	const selectedState = useStore(selector);
	const [debouncedState, setDebouncedState] = useState<T>(selectedState);

	useEffect(() => {
		const timeoutCurrent = timeout.current;
		if (timeoutCurrent) clearTimeout(timeoutCurrent);

		timeout.current = setTimeout(() => {
			setDebouncedState(selectedState);
		}, debounceTime);

		return () => {
			if (timeoutCurrent) clearTimeout(timeoutCurrent);
		};
	}, [debounceTime, selectedState]);

	return [selectedState, debouncedState];
};

export default useDebounceStore;
